import "./Login.scss";
import {
  Link,
  Outlet,
  Route,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { MdClose } from "react-icons/md";
import axios from "axios";
import jwtDecode from "jwt-decode";

function Login() {
  // Login Process
  const [userid, setUserId] = useState("");
  const [userpwd, setUserPwd] = useState("");
  const [checkPwdMsg, setCheckPwdMsg] = useState("");
  const [checkIdMsg, setCheckIdMsg] = useState("");
  const heighL = useRef();
  const btnWidth = useRef();
  const location = useLocation();
  let navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/login/userlogin") {
      sliding(0);
    }
    if (location.pathname === "/login/committee") {
      sliding(btnWidth.current.offsetWidth);
    }
  }, [location]);

  const onChangeId = ({ target: { value } }) => {
    setCheckIdMsg("");
    setUserId(value);
  };
  const onChangePwd = ({ target: { value } }) => {
    setCheckPwdMsg("");
    setUserPwd(value);
  };
  const [passwordType, setPasswordType] = useState({
    type: "password",
    visible: false,
  });

  const handlePasswordType = (e) => {
    setPasswordType(() => {
      if (!passwordType.visible) {
        return { type: "text", visible: true };
      }
      return { type: "password", visible: false };
    });
  };

  const LoginOK = async () => {
    const params = new URLSearchParams();
    params.append("id", userid);
    params.append("password", userpwd);
    await axios
      .post("/api/applicant-login", params)
      .then((response) => {
        window.sessionStorage.setItem("token", response.data.jwt);
      })
      // navigate("/");
      // alert("로그인 성공");
      .catch((error) => {
        console.log(error);
        console.log(error);
      });

    const isLogin = window.sessionStorage.getItem("token");
    //  console.log(`isLogin = ${isLogin}`)
    if (isLogin !== null) {
      // console.log(JSON.stringify(jwtDecode(isLogin)));
      let jwtdec = jwtDecode(isLogin);
      if (jwtdec.obj.state.toUpperCase() === "APPLIED") {
        window.sessionStorage.setItem("applied", true);
      } else {
        window.sessionStorage.setItem("applied", false);
      }
      // alert("로그인 성공");
      window.location.replace("/");
    } else {
      window.sessionStorage.clear();
      alert("로그인에 실패 하였습니다. 로그인 정보를 다시 확인 하십시오.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await LoginOK();
  };

  useEffect(() => {
    heighL.current.style.width = btnWidth.current.offsetWidth + "px";
    heighL.current.style.height = btnWidth.current.offsetHeight + "px";
  });

  function sliding(val) {
    heighL.current.style.left = val + "px";
  }

  return (
    <>
      <div className="tab_btns_wrap login_tab_wrap">
        <div className="tab_btns login_tab">
          <button
            className="tabBtn"
            ref={btnWidth}
            onClick={() => {
              sliding(0);
              navigate("/login/userlogin");
            }}
          >
            신청기관 로그인
          </button>
          <button
            className="tabBtn"
            ref={btnWidth}
            onClick={() => {
              sliding(btnWidth.current.offsetWidth);
              navigate("/login/committee");
            }}
          >
            위원회 로그인
          </button>
        </div>
        <span ref={heighL} className="slidebar"></span>
      </div>
      <Outlet></Outlet>
    </>
  );
}
// function FindId() {
//   const [staffEmail1, setStaffEmail1] = useState("");
//   const [staffName, setStaffName] = useState("");

//   const onClickFindId = async () => {
//     axios.get(`/api/applicant-find-id`, {
//       params: {
//         staffEmail: staffEmail1,
//         staffName: staffName,
//       },
//     });
//   };

//   return (
//     <div className="input_bg">
//       <div className="input_wrap">
//         <input
//           className="input_box"
//           type="text"
//           placeholder="대표자명을 입력해 주세요."
//           onChange={(e) => {
//             e.preventDefault();
//             setStaffName(e.target.value);
//           }}
//         />
//       </div>
//       <div className="input_wrap">
//         <input
//           className="input_box"
//           type="text"
//           placeholder="이메일을 입력해 주세요."
//           onChange={(e) => {
//             e.preventDefault();
//             setStaffEmail1(e.target.value);
//           }}
//         />
//       </div>
//       <button type="button" className="btn_color" onClick={onClickFindId}>
//         아이디찾기
//       </button>
//     </div>
//   );
// }

// function FindPw() {
//   const [userid, setUserID] = useState("");
//   const [staffEmail1, setStaffEmail1] = useState("");

//   const onClickFindPw = async () => {
//     axios.get(`/api/applicant-find-pw`, {
//       params: {
//         id: userid,
//         staffEmail: staffEmail1,
//       },
//     });
//   };

//   return (
//     <div className="input_bg">
//       <div className="input_wrap">
//         <input
//           className="input_box"
//           type="text"
//           placeholder="아이디를 입력해 주세요."
//           onChange={(e) => {
//             setUserID(e.target.value);
//           }}
//         />
//       </div>
//       <div className="input_wrap">
//         <input
//           className="input_box"
//           type="text"
//           placeholder="이메일을 입력해 주세요."
//           onChange={(e) => {
//             setStaffEmail1(e.target.value);
//           }}
//         />
//       </div>
//       <button type="button" className="btn_color" onClick={onClickFindPw}>
//         비밀번호찾기
//       </button>
//     </div>
//   );
// }
export default Login;
